export const ItLocale = {
    page: {
        txtTitle: 'UNVOX | Rimuovi voci all\'istante',
    },
    global: {
        brand: {
            txtName: 'unvox.ai',
            txtLogoAlt: 'logo unvox',
        },
        action: {
            txtBack: 'Indietro',
            txtRetry: 'Riprova',
            txtStartOver: 'Ricomincia',
        },
        job: {
            txtCheckingStatus: 'Verifica dello stato del job',
            txtIdLabel: 'ID job',
        },
        footer: {
            linkPrivacyPolicy: 'Informativa sulla privacy',
            linkTerms: 'Termini',
            linkRefunds: 'Rimborsi',
            linkSupport: 'Supporto',
            txtAllRightsReserved: 'Tutti i diritti riservati.',
            txtBugReportsAndFeatures: 'Segnalazioni bug e richieste funzionalità',
        },
        share: {
            title: 'UNVOX | Rimuovi la voce dalle canzoni con un clic',
            text: 'Trasforma facilmente le tue canzoni preferite in strumentali pronti per il karaoke!',
        },
    },
    route: {
        home: {
            txtHeroKicker: '',
            txtHeroTitle: 'Rimozione voce con un clic',
            txtHeroSubtitle: 'Strumentali istantanei dalla tua traccia o direttamente da YouTube',
            txtInputTypeLabel: 'Tipo di input',
            txtInputTypeFile: 'Carica file audio',
            txtInputTypeYoutube: 'Link YouTube',
            txtInputFilePick: 'Scegli file',
            txtInputFileSub: 'Formati audio comuni ({{formats}}), fino a {{size}} MB.',
            txtPreviewAction: 'Rimuovi voci',
            txtPreviewFailed: 'Si è verificato un errore sconosciuto. Riprova più tardi.',
            txtUploadSelectFile: 'Nessun file selezionato',
            txtYoutubeLabel: 'URL YouTube',
            txtYoutubePlaceholder: 'https://youtube.com/watch?v=...',
            txtYoutubeHelper: 'Incolla un link YouTube pubblico.',
            txtYoutubeMissing: 'Incolla un URL YouTube.',
            txtYoutubeInvalid: 'Inserisci un URL YouTube valido.',
            txtYoutubeTooLong: 'Questo video dura più di 15 minuti. Scegli un video più corto.',
            txtCheckoutUploadFailed: 'Caricamento non riuscito. Riprova.',
            txtUploadMissing: 'Scegli un file prima del caricamento.',
            txtFileTypeInvalid: 'Tipo di file non supportato. Carica un file audio (es. {{formats}}).',
            txtFileTooLarge: 'File troppo grande. Dimensione massima: {{size}} MB.',
        },
        previewJob: {
            txtUnavailableTitle: 'Impossibile creare l\'anteprima',
            txtUnavailableBody: 'Si è verificato un errore sconosciuto. Riprova più tardi.',
            txtPreparingTitle: 'Preparazione anteprima',
            txtPreparingBody: 'Potrebbero volerci fino a 2 minuti',
        },
        payment: {
            txtUnavailableTitle: 'Impossibile creare l\'anteprima',
            txtUnavailableBody: 'Si è verificato un errore sconosciuto. Riprova più tardi.',
            txtPreparingTitle: 'Preparazione anteprima',
            txtCheckoutCancelledBody: 'Nessun addebito effettuato. Puoi riprovare in qualsiasi momento.',
            txtTrackPreviewLabel: 'Anteprima traccia',
            txtTrackPreviewHelper: 'Questa anteprima è una clip di 15 secondi della tua traccia per la valutazione',
            txtEmailLabel: 'Indirizzo e-mail',
            txtEmailPlaceholder: 'yourname@email.com',
            txtEmailCheckoutHelper: 'Lo useremo per inviarti il link di download.',
            txtCheckoutAction: 'Rimuovi voci a soli {{price}}',
            txtCheckoutActionFallback: 'Rimuovi voci',
            txtCheckoutFailed: 'Impossibile avviare il checkout. Riprova.',
            txtInvalidEmail: 'Inserisci un indirizzo e-mail valido.',
        },
        processing: {
            txtMissingTitle: 'ID job mancante',
            txtMissingBody: 'Questa pagina richiede un ID job. Avvia una nuova anteprima.',
            txtMissingAction: 'Torna al caricamento',
            txtStatusFailed: 'Impossibile recuperare lo stato del job. Riprova.',
            txtErrorTitle: 'Qualcosa è andato storto',
            txtSupportAction: 'Contatta il supporto',
            txtConfirmingTitle: 'Conferma pagamento',
            txtConfirmingBody: 'Confirming payment status',
            txtPolling: 'Controllo aggiornamenti',
            txtWorkingTitle: 'Elaborazione della traccia completa',
            txtWorkingBody: 'This will take a few minutes. You will receive an email when the track is ready.',
            txtWorkingAction: 'Avvia un altro',
            txtReadyTitle: 'Download pronto',
            txtReadyBody: 'Il tuo strumentale è pronto per il download.',
            txtDownloadAction: 'Scarica',
            txtDownloadNote: 'This download link expires in 72 hours and will be emailed to you.',
            txtReadyAction: 'Avvia un altro',
        },
        invalidJob: {
            txtTitle: 'ID job non valido',
            txtBody: 'Job non trovato. Avvia un nuovo caricamento.',
            txtAction: 'Ricomincia',
        },
        refund: {
            txtEyebrow: 'Legal',
            txtTitle: 'Refund Policy',
            txtLastUpdatedLabel: 'Last updated',
            txtLastUpdatedDate: 'February 17, 2026',
            txtIntro: 'All purchases are final. We do not issue refunds.',
            txtSectionServiceErrorsTitle: 'Service Errors and Reprocessing',
            txtSectionServiceErrorsBody: 'We want our users to be satisfied with the Service. If an error occurs on our side, we will reprocess your files at no additional cost.',
            txtServiceErrorsItemJobFailed: 'If a job fails due to a technical issue in the Service, we will rerun it.',
            txtServiceErrorsItemDeliveryFailed: 'If output delivery fails due to our systems, we will redeliver your results.',
            txtSectionHelpTitle: 'How to Request Help',
            txtSectionHelpBody: 'Contact Support and include your job ID and the email address you used at checkout. We may ask for additional details to diagnose and reprocess your job.',
            txtNoRefundsNote: 'No refunds will be issued.',
        },
        support: {
            txtEyebrow: 'Supporto',
            txtTitle: 'Contatta il supporto',
            txtLastUpdatedLabel: 'Ultimo aggiornamento',
            txtLastUpdatedDate: '9 febbraio 2026',
            txtSectionEmailTitle: 'E-mail',
            txtSectionEmailBodyPrefix: 'Scrivici a',
            txtSectionIncludeJobIdTitle: 'Includi il tuo ID job',
            txtSectionIncludeJobIdBody: 'Includi il tuo ID job così possiamo trovarlo rapidamente. Se hai pagato, includi anche l\'e-mail usata al checkout.',
            txtSectionBugReportsTitle: 'Segnalazioni bug',
            txtSectionBugReportsBody: 'Puoi anche inviare segnalazioni bug e richieste funzionalità tramite il link nel footer.',
        },
        bugReportsFeatures: {
            txtEyebrow: 'Feedback',
            txtTitle: 'Segnalazioni bug e richieste funzionalità',
            txtSubtitle: 'UNVOX è nelle fasi iniziali. Se qualcosa non va o hai un\'idea, inviala. Segnalazioni chiare sono il modo più veloce per pubblicare correzioni.',
            txtWhatToIncludeTitle: 'Cosa includere',
            txtChecklistExpectedVsActual: 'Cosa ti aspettavi vs cosa è successo',
            txtChecklistSteps: 'Passaggi per riprodurre (1, 2, 3)',
            txtChecklistBrowserOs: 'Il tuo browser e il tuo OS',
            txtChecklistJobId: 'ID job (se era coinvolto un caricamento)',
            txtTipTitle: 'Suggerimento',
            txtTipBody: 'Se ci scrivi via e-mail, puoi rispondere direttamente all\'e-mail di consegna ricevuta e incollare il modello.',
            txtTemplateTitle: 'Modello copia-incolla',
            txtTemplateBody: 'Segnalazione bug / Richiesta funzionalità\n\nTipo: bug | feature\nRiepilogo:\n\nDettagli:\n- Cosa è successo:\n- Cosa ti aspettavi:\n- Passaggi per riprodurre:\n  1.\n- Browser/OS:\n\nOpzionale:\n- ID job:\n- URL YouTube:\n- Screenshot/video:\n',
            txtTemplatePageLabel: 'Pagina',
            txtTemplateUserAgentLabel: 'User agent',
            txtCopyActionIdle: 'Copia modello',
            txtCopyActionCopied: 'Copiato',
            txtCopyActionFailed: 'Copia non riuscita',
            txtCopyHelpFailed: 'L\'accesso agli appunti è stato bloccato. Puoi comunque selezionare il testo sopra e copiarlo manualmente.',
            txtCopyHelpIdle: 'Nulla qui viene inviato automaticamente. Questa pagina ti aiuta solo a formattare una buona segnalazione.',
        },
    },
};
